import React from 'react'
import { SignInContext, SignInContextType } from '@account/contexts/signin'

export const useSignInContext = (): SignInContextType => {
  const context = React.useContext(SignInContext)
  if (context === undefined) {
    throw new Error('useSignInContext must be used within a SignInProvider')
  }
  return context
}
